import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

// COMPONENTS
import { ButtonContained } from '../app-button/button'
import renderSelectField from '../app-form/field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'
import { required } from '../app-form/validation/validation'
import Typography from '@material-ui/core/Typography'
import Spinner from '../spinner'

class DatasetForm extends Component {
  state = {
    selectedDataset: null,
  }

  handleChangeDataset = event => {
    this.setState({ selectedDataset: event.target.value })
  }

  render() {
    const { handleSubmit, datasets, isFetching, datasetsItem } = this.props

    const dataset = datasets.filter(
      dataset => dataset.id === this.state.selectedDataset
    )

    const renderItem = data => {
      if (data) {
        return data.linkedViews.map(linkedView => (
          <li key={linkedView.id}>
            <Typography variant="body2">{linkedView.name}</Typography>
          </li>
        ))
      } else {
        return null
      }
    }

    return (
      <form onSubmit={handleSubmit}>
        <div style={{ width: 343 }}>
          <Field
            name="dataset"
            component={renderSelectField}
            onChange={this.handleChangeDataset}
            value={this.state.selectedDataset}
            validate={[required]}
          >
            <MenuItem value="" style={{ display: 'none' }}>
              <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                Выберите набор данных
              </span>
            </MenuItem>
            {datasets.map(dataset => (
              <MenuItem key={dataset.id} value={dataset.id}>
                {dataset.name}
              </MenuItem>
            ))}
          </Field>
        </div>
        <Typography variant="body2" style={{ marginTop: 16 }}>
          Импортированные в GA данные будут доступны для построения отчетов во
          всех представлениях, связанных с этим набором данных:
        </Typography>
        {dataset || datasetsItem ? (
          <React.Fragment>
            <ol style={{ paddingLeft: 15, marginTop: 5 }}>
              {dataset[0]
                ? renderItem(dataset[0])
                : renderItem(datasetsItem[0])}
            </ol>

            <ButtonContained
              full={true}
              style={{
                height: 48,
                fontSize: 16,
                width: 343,
                padding: 0,
                fontWeight: 700,
                color: '#fff',
              }}
              type="submit"
              color="secondary"
              text={isFetching ? <Spinner /> : 'Сохранить'}
            />
          </React.Fragment>
        ) : null}
      </form>
    )
  }
}

DatasetForm = reduxForm({
  form: 'DatasetForm',
})(DatasetForm)

export default DatasetForm
